(function () {
    const urlParams = new URLSearchParams(window.location.search);
    const debug = urlParams.get("gar_debug") === "true";
    const log = (...a) => debug && console.log("🟢 product-state-event:", ...a);

    document.addEventListener("DOMContentLoaded", () => {
        const el = document.querySelector("product-info");

        if (!el) {
            log("⚠️ No <product-info> element found.");
            return;
        }

        // === Read minimal safe Liquid-derived values ===
        const productId = Number(el.dataset.productId);
        const variantId = Number(el.dataset.variantId);

        // Read YOUR updated attribute name
        const isLive = el.getAttribute("is-live-product") === "true";

        const contentId =
            productId && variantId
                ? `shopify_LT_${productId}_${variantId}`
                : null;

        // === UNIQUE ID TRACKING ===
        if (contentId && isLive) {
            try {
                const key = "viewed_content_ids";
                const raw = localStorage.getItem(key);
                let viewed = raw ? JSON.parse(raw) : [];

                if (!Array.isArray(viewed)) viewed = [];

                if (!viewed.includes(contentId)) {
                    viewed.push(contentId);
                    localStorage.setItem(key, JSON.stringify(viewed));
                    log("Added new LIVE contentId:", contentId);
                } else {
                    log("Live contentId already present:", contentId);
                }
            } catch (e) {
                log("⚠️ Error updating contentId list:", e);
            }
        } else {
            log("Skipping ID tracking:", { contentId, isLive });
        }

        // === Save product state ===
        try {
            localStorage.setItem(
                "product_state",
                JSON.stringify({ isLive, contentId })
            );
            log("Saved product_state:", { isLive, contentId });
        } catch (e) {
            log("⚠️ Failed saving product_state:", e);
        }

        // === Publish event ===
        if (window.Shopify?.analytics?.publish) {
            Shopify.analytics.publish("product_state", { isLive, contentId });
            log("Published product_state", { isLive, contentId });
        } else {
            log("⚠️ Shopify.analytics.publish unavailable");
        }

        log("Ready.");
    });
})();
